import { Injectable, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../common/services/api.service';
import { getTreeNoValidDataSourceError } from '@angular/cdk/tree';
import API from '../../../modules/common/services/api.config.json';

@Injectable()

export class AgendaService {

  isLoading: boolean = false;
  isLoading1: boolean = false;
  isLoading2: boolean = false;
  isLoading4: boolean = false;

  @Output() DateTaskCount: EventEmitter<any> = new EventEmitter<any>();

  public dayBefore = 0;
  public yesterday = 0;
  public today = 0;
  public tomorrow = 0;
  public dayAfter = 0;
  public bajasActivasCount = 0;
  // public tareasHoyCount = 0;
  // public atuacionesCount = 0;

  @Output() tareasHoyCount: EventEmitter<number> = new EventEmitter<number>();
  @Output() atuacionesCount: EventEmitter<number> = new EventEmitter<number>();

  constructor(public apiService: ApiService) { }

  getTasks() {

  }


  setTareasCount(empressaId) {
    this.getDayTaskCount(empressaId).then(
      res => {

      }
    )
  }

  getTareasCount(empressaId, fechaType) {
    // this.isLoading1 = true;
    return new Promise((resolve, reject) => {
      let today = new Date();
      let empressaObj = {
        "empresaId": empressaId,
        "fecha": today,
      }
      this.apiService.post(API.Doctor.getselected_doctor_taskcount, empressaObj, true).subscribe(
        res => {
          if (res.code == 0) {
            // this.isLoading1 = false;
            resolve(res)
          } else {
            reject()
            // this.isLoading1 = false;
          }
        }),
        err => {
          reject();
        }
    })
  }

  getDayTaskCount(empressaId) {
    this.isLoading = true;
    return new Promise<void>((resolve, reject) => {
      this.getTareasCount(empressaId, 'DayBefore').then(res => {
        let response: any;
        response = res;
        let responseBody = response;       
        if (responseBody.result == null) {
          this.DateTaskCount.emit(0);
          this.isLoading = false;
          resolve();
        } else {
          // this.dayBefore =
          this.DateTaskCount.emit(responseBody.result)
          this.isLoading = false;
          resolve()
        }
      })
    })

  }

  getTareasData(empressaId, date, fechaType) {
    this.isLoading = true;
    const c = new Promise((resolve, reject) => {
      const empressaObj = {
        "empresaId": empressaId,
        "fecha": date,
        "fechaType": fechaType
      };

      this.apiService.post(API.Doctor.getselected_doctor_task, empressaObj, true).subscribe(res => {
        if (res.code === 0) {
          this.isLoading = false;
          resolve(res);
        } else {
          this.isLoading = false;
          reject();
        }
      },
        err => {
          this.isLoading = false;
          reject(err);
        });
    });
    return c;

  }

  getBajasActivasCount(empressaId) {
    this.isLoading4 = true;
    return new Promise<void>((resolve, reject) => {
      const url: string = `${API.MedicoView.getBajasActivasCount}`.replace('{empresaId}', empressaId);
      this.apiService.get(url).subscribe(res => {
        if (res == null) {
          this.bajasActivasCount = 0;
          this.isLoading4 = false;
          resolve();
        } else {
          this.bajasActivasCount = res.result;
          this.isLoading4 = false;
          resolve();
        }
      }, err => {
        console.error('Error on bajas activas count', err);
        reject();
      });
    });
  }

  getTareasHoyCount(empressaId) {
    this.isLoading2 = true;
    return new Promise<void>((resolve, reject) => {
      const url: string = `${API.MedicoView.getTareasHoyCount}`.replace('{empresaId}', empressaId);
      this.apiService.get(url).subscribe(res => {
        if (res == null) {
          this.tareasHoyCount.emit(0);
          this.isLoading2 = false;
          resolve();
        } else {
          this.tareasHoyCount.emit(res.result);
          this.isLoading2 = false;
          resolve();
        }
      }, err => {
        console.error('Error on Tareas Hoy count', err);
        reject();
      });
    });
  }


  getActuacionesCount(empressaId) {
    this.isLoading1 = true;
    return new Promise<void>((resolve, reject) => {
      const url: string = `${API.MedicoView.getActuacionesCount}`.replace('{empresaId}', empressaId);
      this.apiService.get(url).subscribe(res => {
        if (res == null) {
          this.atuacionesCount.emit(0);
          this.isLoading1 = false;
          resolve();
        } else {
          this.atuacionesCount.emit(res.result);
          this.isLoading1 = false;
          resolve();
        }
      }, err => {
        console.error('Get Actuation count error ', err);
        reject();
      });
    });
  }

}




